import script from "./FeedbackManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackManagement.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackManagement.vue?vue&type=style&index=0&id=7b61d7bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b61d7bb"]])

export default __exports__